import React from "react";
import OilProductionmaterilsLog from "./oilProductionLog";
import { BreadCrumb } from "primereact/breadcrumb";
 const breadcrumbItems = [
    { label: "Oil Production", url: "" },
    { label: "Oil Production Log", url: "" }
  ];
  const home = { icon: "pi pi-home", url: "/" };

const OilProductionLog: React.FC = () => {
  return (
    <div className="p-4 shadow-lg rounded-lg bg-white">
      <h4 className="border-round order-top-color p-2 mb-2">Oil Production Log</h4>
      {/* <BreadCrumb model={breadcrumbItems} home={home} 
                className=" mb-1 bg-transparent px-0 py-0 text-sm  text-gray-600" 
                style={{
          border: "none",
          boxShadow: "none",
          background: "transparent",
          marginLeft: "11px",
        }}/> */}
      <OilProductionmaterilsLog />
      
    </div>
    
  );
};

export default OilProductionLog;
